import moment from "moment";
import { formatDate } from "react-lib/utils/dateUtils";
import { HeaderLogoWithAddress } from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";

const FORM_NAME = "FormORCaseStatList";

const FormORCaseList = async (props: any) => {
  const headerForm = await HeaderLogoWithAddress({
    pageMargins: [15, 140, 0, 50],
    font: "THSarabunNew",
    form: FORM_NAME,
    logoHeight: 38,
    styles: {
      title: {
        bold: true,
        fontSize: 20,
        alignment: "center",
      },
      header: {
        fontSize: 18,
        alignment: "center",
      },
      tableHeader: {
        fontSize: 16,
        alignment: "center",
      },
      tableDetail: {
        fontSize: 14,
      },
      addressRightStyle: {
        fontSize: 12,
        alignment: "right",
      },
      addressLeftStyle: {
        fontSize: 12,
        alignment: "left",
      },
    },
    titleContent: [
      {
        text: "รายงานสถิติการใช้บริการห้องผ่าตัด",
        style: "title",
      },
      {
        text: `วันที่ ${props?.start_date} - ${props?.end_date}`,
        style: "header",
      },
    ],
  });
  const { font, images, styles } = headerForm;

  return {
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 12,
    },
    pageSize: "A4",
    pageOrientation: "landscape",
    ...styles,
    ...headerForm,
    content: [
      {
        margin: [20, 0, 10, 10],
        table: {
          widths: ["*", "10%", "10%", "10%", "10%", "10%"],
          body: [
            [
              { text: "Location/Room", style: "tableHeader", bold: true },
              { text: "Cases", style: "tableHeader", bold: true },
              { text: "Anesthesia", style: "tableHeader", bold: true },
              { text: "Age range", style: "tableHeader", bold: true },
              { text: "Gender", style: "tableHeader", bold: true },
              { text: "QTY", style: "tableHeader", bold: true },
            ],
            ...(props?.data || []).map((item: any, index: number) => [
              {
                text: item.locationRoom,
                style: "tableDetail",
              },
              {
                text: item.caseText,
                style: "tableDetail",
                alignment: "center",
              },
              {
                text: item.anesthesia_method_name,
                style: "tableDetail",
                alignment: "center",
              },
              {
                text: item.ageRangeText,
                style: "tableDetail",
                alignment: "center",
              },
              { text: item.gender, style: "tableDetail", alignment: "center" },
              { text: item.count, style: "tableDetail", alignment: "center" },
            ]),
          ],
        },
      },
    ],
    footer: function (currentPage: number, pageCount: number) {
      const printDateMM = moment();
      return {
        stack: [
          {
            margin: [40, 0, 20, 0],
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: `วันเวลาที่พิมพ์ : ${formatDate(printDateMM)} [${printDateMM.format(
                      "HH:mm"
                    )}]`,
                    style: "addressLeftStyle",
                  },
                  {
                    text: `ผู้ออกรายงาน : ${props?.print_user || ""}`,
                    style: "addressLeftStyle",
                  },
                ],
              },
              {
                width: "50%",
                stack: [
                  {
                    text: `หน้าที่ ${currentPage} / ${pageCount}`,
                    style: "addressRightStyle",
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    images: {
      ...images,
    },
  };
};

export default FormORCaseList;
